import React, { useEffect, useMemo, useState } from "react";
import { Notification, userBackend } from "../../services";
import NotificationIcon from "./icon";
import { formatRelativeDate } from "../../utils";
import { toast } from "sonner";
import { CloseIcon } from "../../icons/close";
import { refreshNotifications } from "./functions";

const NotificationItem = (props: { data: Notification }) => {
  const { data } = props;

  const goTo = (url?: string) => {
    userBackend
      .readNotification(data.id)
      .catch((e) => {
        console.log(e);
        toast("Ошибка сохранения статистики");
      })
      .finally(() => {
        if (url) {
          document.location.href = url;
        } else {
            refreshNotifications();
        }
      });
  };

  return (
    <div className={`notificationItem flex gap24 ${!data.read ? "unread" : "read"}`}>
      <NotificationIcon data={data} />
      <div className="notificationBody columnLeft gap6">
        <h5 className="notifyItemHeading">{data.title}</h5>
        <div className="notifyItemText">{formatRelativeDate(data.date * 1000)}</div>
        {data.description && (
          <div className="notifyItemText">{data.description}</div>
        )}
        <a className="notifyItemUrl" onClick={goTo.bind(this, data.url)}>{`${
          !data.url ? "Прочитано" : "Перейти"
        }`}</a>
      </div>
      <div className="closeNotifyIcon" onClick={goTo.bind(this, undefined)}>
        <CloseIcon width={18} height={18} />
      </div>
    </div>
  );
};

export default NotificationItem;
